import { default as DataTableComponent } from 'dashboard/components-lib/DataTable';
import { ModuleDataTable } from 'dashboard/modules/DataTable/model';
import Card from 'design-system/components/Card';

export interface DataTableProps {
  module: ModuleDataTable;
  tableData: any[];
}

const DataTable = ({ module, tableData }: DataTableProps) => {
  const columns = module.columns.map((column) => ({
    accessor: column.key,
    header: column.label,
  }));

  return (
    <Card>
      <Card.Body>
        <DataTableComponent data={tableData} columns={columns}></DataTableComponent>
      </Card.Body>
    </Card>
  );
};

export default DataTable;
